/**
 * Returns the full path to the settings page of a Battery-Settings of a specific installation
 */
export const getStorageBatteriesSettingsRoute = (installationId = ':installationId', storageId = ':storageId'): string => {
  return `/installation/${installationId}/${storageId}/properties/batteries`
}
